import checkin from "./checkin";
import accidentreport from "./accidentreport";
import evaluation from "./evaluation";
import docket from "./docket";
import trainingproof from "./trainingproof";
import personaccidentreport from "./personaccidentreport";

export default {
  checkin,
  accidentreport,
  evaluation,
  docket,
  trainingproof,
  personaccidentreport
}
